/**
 * Стартовый раздел левого меню — до первого кадра.
 *
 * В разметке ни один `.view` / `.nav-btn` не помечен `active`: иначе первый
 * кадр всегда показывал бы один и тот же раздел, а auth-флоу (после ответа
 * сервера) переключал бы подсветку на фактический — визуальное «перепрыгивание».
 *
 * Здесь раздел выбирается синхронно, до любых await и сетевых запросов, по тем
 * же признакам, что и сам auth-флоу: есть токен → «Разговор», иначе Free-режим
 * → «Диалог» (точка входа гостя). Async-флоу затем подтверждает этот выбор, и
 * подсветка никуда не прыгает. Если токен окажется невалидным, флоу уведёт на
 * «Диалог» — редкий путь ошибки.
 */
export function presetInitialView(): void {
  const name = localStorage.getItem('avgexpert_token') ? 'conversation' : 'avg-dialog';
  document.getElementById('view-' + name)?.classList.add('active');
  document.querySelector(`.nav-btn[data-view="${name}"]`)?.classList.add('active');
}
